const ITEMS = [
  "SAME PLANET. BIGGER QUESTIONS.",
  "FROM ORBIT TO ICE",
  "63°S · ANTARCTIC PENINSULA",
  "EARTH OBSERVATION",
  "GEOSPATIAL AI",
  "PROPOSED · DEC 2027 – 2029",
];

export default function Marquee() {
  const row = (
    <>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center gap-10 shrink-0">
          <span className="font-display font-semibold uppercase tracking-[0.12em] text-2xl sm:text-3xl text-ice/25">{t}</span>
          <span className="w-2 h-2 rotate-45 bg-mission/60 shrink-0" aria-hidden="true" />
        </span>
      ))}
    </>
  );
  return (
    <div className="relative py-7 border-y border-polar/10 bg-abyss/50 overflow-hidden" aria-hidden="true" data-testid="editorial-marquee">
      <div className="marquee-track flex gap-10 w-max">
        {row}
        {row}
      </div>
    </div>
  );
}
